// extracted by mini-css-extract-plugin
module.exports = {"background":"styles_background__19SoZ","stars":"styles_stars__3W2OV","mountains":"styles_mountains__3GVDs","road":"styles_road__fqN2_"};